import Component from '@glimmer/component';
import pageTitle from 'ember-page-title/helpers/page-title';
import scrollToAnchor from 'bcl/modifiers/scroll-to-anchor';
import PageSetup from 'bcl/components/page-setup';
import HeroIcon from 'bcl/components/hero-icon';
import Company from 'bcl/components/basic-data/company';
import Items from 'bcl/components/basic-data/items';
import Locations from 'bcl/components/basic-data/locations';
import Suppliers from 'bcl/components/basic-data/suppliers';
import Section from 'bcl/components/section';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type SupplierModel from 'bcl/models/supplier';
import type NotificationService from 'bcl/services/notification';
import type SessionService from 'bcl/services/session';
import type CompanyModel from 'bcl/models/company';
import type ItemModel from 'bcl/models/item';
import type LocationModel from 'bcl/models/location';
interface BasicDataSignature {
  // The arguments accepted by the component
  Args: {
    model: {
      company: CompanyModel;
      items: ItemModel[];
      locations: LocationModel[];
      suppliers: SupplierModel[];
    };
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class BasicDataRoute extends Component<BasicDataSignature> {
  @service declare session: SessionService;
  @service declare router: RouterService;
  @service declare notification: NotificationService;

  @action
  cancelCompany() {
    this.args.model.company.rollbackAttributes();
    this.notification.success('Unternehmensdaten wurden zurückgesetzt.');
  }
  @action
  async saveCompany() {
    await this.args.model.company.save();
    this.notification.success('Unternehmensdaten wurden gespeichert.');
  }

  @action
  newOrder(supl: SupplierModel) {
    this.session.orderKind = 'frei';
    this.session.orderSuplID = supl.id;
    this.router.transitionTo('auth.orders.new');
  }
  <template>
    {{pageTitle "Stammdaten"}}
    {{outlet}}
    <PageSetup @title="Stammdaten" {{scrollToAnchor}} @noWrapper={{true}}>
      <:header>
        <span class="ml-8 font-normal">
          <a
            class="inline-flex text-blue-400 hover:text-blue-600 rounded-md cursor-pointer"
            href="#items"
          >
            <HeroIcon @icon="arrow-top-right-on-square" class="size-6" />
            Artikel
          </a>
          <a
            class="ml-4 inline-flex text-blue-400 hover:text-blue-600 rounded-md cursor-pointer"
            href="#locations"
          >
            <HeroIcon @icon="arrow-top-right-on-square" class="size-6" />
            Lager
          </a>
          <a
            class="ml-4 inline-flex text-blue-400 hover:text-blue-600 rounded-md cursor-pointer"
            href="#suppliers"
          >
            <HeroIcon @icon="arrow-top-right-on-square" class="size-6" />
            Lieferanten
          </a>

        </span>
      </:header>
      <:default>
        <div class="print:mt-0 mx-auto max-w-7xl print:max-w-none">
          <Section>
            <Company
              @model={{@model.company}}
              @save={{this.saveCompany}}
              @cancel={{this.cancelCompany}}
            />
          </Section>
          <Section>
            <Items @model={{@model.items}} />
          </Section>
          <Section>
            <Locations
              @model={{@model.locations}}
              @cancel={{this.cancelCompany}}
            />
          </Section>
          <Section>
            <Suppliers
              @model={{@model.suppliers}}
              @newOrder={{this.newOrder}}
            />
          </Section></div>
      </:default>
    </PageSetup>
  </template>
}
